export default __webpack_public_path__ + "static/media/231.246bbbf7.png";